import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  FormHelperText,
  Checkbox,
  ListItemText,
  Switch,
  FormControlLabel,
  CircularProgress,
  Grid,
} from "@mui/material";
import { getAdminData, apiPaths } from "../../platform-components/api-integration-util";

const AddUserModal = ({
  open,
  onClose,
  formData,
  handleInputChange,
  handleBranchChange,
  handleSubmit,
  branches,
  roles = [],
  isEditMode = false,
}) => {
  const [loading, setLoading] = useState(false);

  const { firstName, lastName, email, branchPermissions, active } = formData;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{isEditMode ? "Edit User" : "Add New User"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              label="First Name"
              name="firstName"
              value={firstName}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="dense"
              label="Last Name"
              name="lastName"
              value={lastName}
              onChange={handleInputChange}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              margin="dense"
              label="Email"
              name="email"
              type="email"
              value={email}
              onChange={handleInputChange}
              fullWidth
              required
              disabled={isEditMode}
            />
          </Grid>

          {!isEditMode && (
            <Grid item xs={12}>
              <TextField
                margin="dense"
                label="Password"
                name="password"
                type="password"
                onChange={handleInputChange}
                fullWidth
                required
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <FormControl fullWidth margin="dense">
              <InputLabel>Roles</InputLabel>
              <Select
                name="roleIds"
                multiple
                value={formData.roleIds || []}
                onChange={handleInputChange}
                renderValue={(selected) =>
                  Array.isArray(selected) && roles.length > 0
                    ? roles
                      .filter((role) => selected.some(s => String(s) === String(role.roleId)))
                      .map((role) => role.roleName)
                      .join(", ")
                    : ""
                }
              >
                {roles.map((role) => (
                  <MenuItem key={role.roleId} value={role.roleId}>
                    <Checkbox
                      checked={Array.isArray(formData.roleIds) && formData.roleIds.some(s => String(s) === String(role.roleId))}
                    />
                    <ListItemText primary={role.roleName} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Select one or more roles</FormHelperText>
            </FormControl>
          </Grid>


          <Grid item xs={12}>
            <FormControl fullWidth margin="dense">
              <InputLabel>Branch Permissions</InputLabel>
              <Select
                name="branchPermissions"
                multiple
                value={branchPermissions}
                onChange={handleBranchChange}
                renderValue={(selected) =>
                  branches
                    .filter((branch) => selected.some(s => String(s) === String(branch.branchId)))
                    .map((branch) => branch.branchName)
                    .join(", ")
                }
              >
                {branches.map((branch) => (
                  <MenuItem key={branch.branchId} value={branch.branchId}>
                    <Checkbox checked={branchPermissions.some(s => String(s) === String(branch.branchId))} />
                    <ListItemText primary={branch.branchName} />
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>Select branches this user can access</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Switch
                  name="active"
                  checked={active}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "active", value: e.target.checked },
                    })
                  }
                />
              }
              label="Active"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained" disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Save"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddUserModal;
